import { IMAGE } from '../elements/assets'
import { LINK_FIELD } from '../elements/link'

export const IMAGE_TEXT_STACK = `
...on imageTextStack_Entry {
  id
  typeHandle

  backgroundColor
  heading {
    html
  }
  
  cardStack {
    ... on cardStack_Entry {
      ${ IMAGE }
      title
      description
      ${ LINK_FIELD }
    }
  }
}
`